import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { type PaginatedResponse, type Property } from '@/api/istaff/property';
import { type PropertyFilters } from '@/@types/propertyFilters';
import { type PropertySearchState, type SearchContext } from './types';

const initialState: PropertySearchState = {
  results: [],
  meta: null,
  loading: false,
  error: null,
  searchContext: null,
  groupFilters: {},
};

export const propertySearchSlice = createSlice({
  name: 'propertySearch',
  initialState,
  reducers: {
    setSearchContext: (state, { payload }: PayloadAction<SearchContext>) => {
      state.searchContext = payload;
    },
    setResults: (
      state,
      { payload }: PayloadAction<PaginatedResponse<Property>>,
    ) => {
      state.results = payload.data;
      state.meta = payload.meta;
      state.loading = false;
      state.error = null;
    },
    setLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.loading = payload;
    },
    setError: (state, { payload }: PayloadAction<string>) => {
      state.error = payload;
      state.loading = false;
    },
    setGroupFilters: (
      state,
      { payload }: PayloadAction<Record<number, PropertyFilters>>,
    ) => {
      state.groupFilters = payload;
    },
    resetGroupFilters: (state) => {
      state.groupFilters = {};
    },
  },
});

export const { reducer: propertySearchReducer } = propertySearchSlice;
